import { CallRequest } from '../../types';

export class FetchModel<CR extends CallRequest<unknown, unknown, unknown>, Data, Error> {
  public readonly callRequest: CR;
  public readonly data: Data;
  public readonly error: Error;
  public readonly pending: boolean;

  public constructor(callRequest: CR, data: Data, error: Error, pending: boolean) {
    this.callRequest = callRequest;
    this.data = data;
    this.error = error;
    this.pending = pending;
  }
}
